import React from 'react';

function LogoutIcon({ fill, className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0499 27.8376H18.8874C13.3374 27.8376 10.6624 25.6501 10.1999 20.7501C10.1499 20.2376 10.5249 19.7751 11.0499 19.7251C11.5499 19.6751 12.0249 20.0626 12.0749 20.5751C12.4374 24.5001 14.2874 25.9626 18.8999 25.9626H19.0624C24.1499 25.9626 25.9499 24.1626 25.9499 19.0751V10.9251C25.9499 5.8376 24.1499 4.0376 19.0624 4.0376H18.8999C14.2624 4.0376 12.4124 5.5251 12.0749 9.5251C12.0124 10.0376 11.5749 10.4251 11.0499 10.3751C10.5249 10.3376 10.1499 9.8751 10.1874 9.3626C10.6124 4.3876 13.2999 2.1626 18.8874 2.1626H19.0499C25.1874 2.1626 27.8124 4.7876 27.8124 10.9251V19.0751C27.8124 25.2126 25.1874 27.8376 19.0499 27.8376Z"
        fill={`${fill}`}
      />
      <path
        d="M18.7499 15.9375H4.5249C4.0124 15.9375 3.5874 15.5125 3.5874 15C3.5874 14.4875 4.0124 14.0625 4.5249 14.0625H18.7499C19.2624 14.0625 19.6874 14.4875 19.6874 15C19.6874 15.5125 19.2624 15.9375 18.7499 15.9375Z"
        fill={`${fill}`}
      />
      <path
        d="M7.31255 20.1248C7.07505 20.1248 6.83755 20.0373 6.65005 19.8498L2.46255 15.6623C2.10005 15.2998 2.10005 14.6998 2.46255 14.3373L6.65005 10.1498C7.01255 9.7873 7.61255 9.7873 7.97505 10.1498C8.33755 10.5123 8.33755 11.1123 7.97505 11.4748L4.45005 14.9998L7.97505 18.5248C8.33755 18.8873 8.33755 19.4873 7.97505 19.8498C7.80005 20.0373 7.55005 20.1248 7.31255 20.1248Z"
        fill={`${fill}`}
      />
    </svg>
  );
}

export default LogoutIcon;
